import React, { PropsWithChildren } from 'react';

import Flex from 'components/widgets/ReportsHome/genericLayouts/genericFlex';

const LayoutLeftRight = ({ children, ...rest }: PropsWithChildren<{ className?: string }>) => {
    return (
        <Flex justify={'space-between'} style={{ width: '100%' }} {...rest}>
            {children}
        </Flex>
    );
};

export default LayoutLeftRight;
